import {
  TICKETING_SET_CURRENT_ROW,
  TICKETING_SET_DATA,
  TICKETING_SET_LAST_PAGE,
  TICKETING_SET_GRID_LOADING,
  TICKETING_SET_RELOAD_DATA,
  TICKETING_SET_TOTAL_ROWS,
  TICKETING_SET_TICKET_DATA,
  TICKETING_SET_TICKET_LOADING,
  TICKETING_SET_PUBLISH_COMMENT_LOADING,
  TICKETING_PUSH_TICKET_MESSAGE,
  TICKETING_SET_TICKET_STATUSES,
  TICKETING_UPDATE_TICKET_DATA,
  TICKETING_TOGGLE_CREATE_TICKET_MODAL,
  TICKETING_SET_TICKET_CATEGORIES,
  TICKETING_SET_LOADING_TICKET_CATEGORIES,
  TICKETING_ADD_TEMPRARY_TICKET_ID,
  TICKETING_REMOVE_TEMPRARY_TICKET_ID,
  TICKETING_SET_CHECK_NEW_TICKETS,
} from './enums/TicketingTypes';

const initialState = {
  grid: {
    data: [],
    lastPage: 0,
    totalRows: 0,
    reloadData: 0,
    loading: false,
  },
  newTicketIdTemp: [], // temporary stored ID on create new ticket, to show "New tickets will appear shortly." message. New ticker appear in the grid after some time
  currentRow: null,
  ticketData: {
    id: '', // example: '141748572362'
    subject: '',
    content: '',
    createdate: '', // example: '2025-05-15T13:47:23.428Z'
    hs_lastactivitydate: '', // example '2025-05-22T09:53:26.870Z'
    status: '', // example: Waiting on customer
    hs_pipeline_stage: '', // example: 2
    messages: [
      {
        owner: '', // Contact Name
        content: '',
        createdAt: '', // example '1747925658579'
      },
    ],
  },
  ticketLoading: false,
  publishCommentLoading: false,
  ticketStatuses: [
    {
      id: '1',
      label: 'New',
    },
    {
      id: '2',
      label: 'In Progress', // original: Waiting on customer
    },
    {
      id: '3',
      label: 'Resolved', // original: Waiting on us
    },
    {
      id: '2148871375',
      label: 'Blocked', // original: Product (Blocked)
    },
    {
      id: '4',
      label: 'Closed',
    },
  ],
  ticketPriorities: {
    LOW: { class: 'text-success', label: 'Low' },
    MEDIUM: { class: 'text-warning', label: 'Medium' },
    HIGH: { class: 'text-danger', label: 'High' },
    URGENT: { class: 'text-danger', label: 'Urgent' },
  },
  ticketCategories: [
    {
      label: 'General inquiry',
      value: 'GENERAL_INQUIRY',
      displayOrder: 4,
      hidden: false,
    },
  ],
  ticketCategoriesLoading: false,
  showCreateModal: false,
};

const TicketingReducer = (state = initialState, action) => {
  switch (action.type) {
    case TICKETING_SET_DATA:
      return { ...state, grid: { ...state.grid, ...action.data } };
    case TICKETING_SET_GRID_LOADING:
      return { ...state, grid: { ...state.grid, loading: action.value } };
    case TICKETING_SET_RELOAD_DATA:
      return {
        ...state,
        grid: { ...state.grid, reloadData: state.grid.reloadData + 1 },
      };
    case TICKETING_SET_CURRENT_ROW:
      return { ...state, currentRow: action.data };

    case TICKETING_SET_TICKET_DATA:
      return { ...state, ticketData: action.data };

    case TICKETING_UPDATE_TICKET_DATA:
      return {
        ...state,
        ticketData: { ...action.data, messages: state.ticketData.messages },
      };

    case TICKETING_SET_TICKET_LOADING:
      return { ...state, ticketLoading: action.value };

    case TICKETING_SET_PUBLISH_COMMENT_LOADING:
      return { ...state, publishCommentLoading: action.value };
    case TICKETING_PUSH_TICKET_MESSAGE:
      return {
        ...state,
        ticketData: {
          ...state.ticketData,
          messages: [...state.ticketData.messages, action.data],
        },
      };
    case TICKETING_TOGGLE_CREATE_TICKET_MODAL:
      return { ...state, showCreateModal: !state.showCreateModal };
    case TICKETING_SET_TICKET_STATUSES:
      return { ...state, ticketStatuses: action.data };
    case TICKETING_SET_TICKET_CATEGORIES:
      return { ...state, ticketCategories: action.data };

    case TICKETING_SET_LOADING_TICKET_CATEGORIES:
      return { ...state, ticketCategoriesLoading: action.value };

    case TICKETING_ADD_TEMPRARY_TICKET_ID:
      return {
        ...state,
        newTicketIdTemp: [...state.newTicketIdTemp, action.value],
      };

    case TICKETING_REMOVE_TEMPRARY_TICKET_ID:
      return {
        ...state,
        newTicketIdTemp: state.newTicketIdTemp.filter(
          (id) => !action.data.includes(id)
        ),
      };
    case TICKETING_SET_CHECK_NEW_TICKETS: {
      const matchingIds = state.newTicketIdTemp.filter((tid) =>
        state.grid.data.map((t) => t.id).includes(tid)
      );

      // remove Ids from newTicketIdTemp
      if (matchingIds.length) {
        return {
          ...state,
          newTicketIdTemp: state.newTicketIdTemp.filter(
            (id) => !matchingIds.includes(id)
          ),
        };
      }
      return state;
    }

    default:
      return state;
  }
};
export default TicketingReducer;
